import Select from "react-select";
import {toast} from "react-toastify";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
    useLazyGetAllCompaniesQuery,
    useLazyGetAllCountriesQuery,
    useGetRolesQuery,
} from "../../../store/service/adbService";
import { greySelectCustomStyles} from "../../../global/customStyles";

const CreateUser1 = () => {
    const { id: userId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const isCreateUserPage = location.pathname === "/create-user/step-1";
    const createUserData = JSON.parse(localStorage.getItem("create-user")) || {};
    const editUserData = JSON.parse(localStorage.getItem("edit-user")) || {};

    const [state, setState] = useState({
        first_name: createUserData.first_name || editUserData.first_name || "",
        last_name: createUserData.last_name || editUserData.last_name || "",
        email: createUserData.email || editUserData.email || "",
        phone: createUserData.phone || editUserData.phone || "",
        company_id: createUserData.company_id || editUserData?.company_id || editUserData?.company?.id || "",
        country_id: createUserData.country_id || editUserData?.country_id ||editUserData?.country?.id || null,
        role: createUserData.role || editUserData?.role || null,
        password: createUserData.password || "",
        force_password_change: editUserData?.force_password_change,
        deactivated: editUserData.deactivated || false,
    });

    const [countries, setCountries] = useState([]);
    const [roles, setRoles] = useState([]);
    const [companiesOptions, setCompaniesOptions] = useState([]);
    const [countriesLoading, setCountriesLoading] = useState(false);
    const [companiesLoading, setCompaniesLoading] = useState(false);

    const { data: rolesData } = useGetRolesQuery();
    const [fetchCountries] = useLazyGetAllCountriesQuery();
    const [fetchCompanies] = useLazyGetAllCompaniesQuery();

    const selectValues = (data) =>
        data?.map((item) => ({ value: item.id, label: item.name })) || [];

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setState((prevState) => ({ ...prevState, [id]: value }));
    };

    const handleCheckboxChange = (key) => (e) => {
        setState((prevState) => ({ ...prevState, [key]: e.target.checked }));
    };

    const handleSelectChange = (key) => (selectedOption) => {
        setState((prevState) => ({ ...prevState, [key]: selectedOption?.value || null }));
    };

    useEffect(() => {
        setCountriesLoading(true);
        fetchCountries({ per_page: 1000 }).then((res) => {
            const data = res?.data?.data?.data || [];
            setCountries(selectValues(data));
        }).finally(() => setCountriesLoading(false));

        setCompaniesLoading(true);
        fetchCompanies({ per_page: 1000 }).then((res) => {
            const data = res?.data?.data?.data || [];
            setCompaniesOptions(selectValues(data.map((item) => ({ id: item.id, name: item.long_name }))));
        }).finally(() => setCompaniesLoading(false));
    }, []);

    // Needed fixing
    useEffect(() => {
        if (rolesData?.data) {
            setRoles(selectValues(rolesData.data.map((item) => ({
                id: item.value,
                name: item.name,
            }))));
            setState((prevState)=>({...prevState, role: rolesData?.data.find((item) => item.name === state.role || item.value === state.role)?.value}))
        }

    }, [rolesData]);

    const navigateToNextStep = (e) => {
        e.preventDefault();

        let isValid = true;

        // Fields to check
        const requiredFields = [
            "first_name",
            "last_name",
            "email",
            "phone",
            "country_id",
            "company_id",
            "role",
        ];

        // Validate required fields
        requiredFields.forEach((field) => {
            if (!state[field] || state[field] === "Invalid date" || state[field] === "") {
                toast.error(`Please enter ${field.replace("_", " ")}`, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000,
                });
                isValid = false;
            }
        });

        // Password validation
        if (!userId) {
            if (!state.password || state.password.length < 8) {
                toast.error("The password must be at least 8 characters.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000,
                });
                isValid = false;
            }
        } else if (state.password && state.password.length < 8) {
            toast.error("The password must be at least 8 characters.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000,
            });
            isValid = false;
        }

        if (isValid) {
            let dataToSave = {};

            if (userId && editUserData) {
                // Include only changed fields for editing
                Object.keys(state).forEach((key) => {
                    if (state[key] !== editUserData[key] && key !=='password') {
                        dataToSave[key] = state[key];
                    }
                });
            } else {
                // For new user creation, include all fields
                dataToSave = { ...state };
            }

            // Add additional fields
            dataToSave.force_password_change = state?.force_password_change ? 1 : 0;
            dataToSave.deactivated = state?.deactivated ? 1 : 0;


            // Save data locally
            if (!userId) {
                localStorage.setItem("create-user", JSON.stringify(dataToSave));
            } else {
                localStorage.setItem("edit-user", JSON.stringify(dataToSave));
            }

            navigate(isCreateUserPage ? "/create-user/step-2" : `/edit-user/${userId}/step-2`);
        }
    };



    return (
        <form className="create__form">
            <div className="create__form-content">
                {[
                    { label: "First name", id: "first_name", type: "text" },
                    { label: "Last name", id: "last_name", type: "text" },
                    { label: "Email", id: "email", type: "text" },
                    { label: "Phone number", id: "phone", type: "number" },
                ].map(({ label, id, type }) => (
                    <div key={id} className="create__form-row">
                        <label className="create__form-label">{label}</label>
                        <div className="create__form-input">
                            <input
                                type={type}
                                id={id}
                                placeholder={`Enter ${label.toLowerCase()}`}
                                value={state[id]}
                                onChange={handleInputChange}
                                maxLength={190}
                            />
                        </div>
                    </div>
                ))}

                {[
                    { label: "Select Country", id: "country_id", options: countries, isLoading: countriesLoading },
                    { label: "Select User Type", id: "role", options: roles, isLoading: false },
                    { label: "Select Company", id: "company_id", options: companiesOptions, isLoading: companiesLoading },
                ].map(({ label, id, options, isLoading }) => (
                    <div key={id} className="create__form-row">
                        <label className="create__form-label">{label}</label>
                        <div className="create__form-input">
                            <Select
                                menuPortalTarget={document.body}
                                styles={({...greySelectCustomStyles,  menuPortal: base => ({...base, zIndex: 9999})})}
                                options={options}
                                isLoading={isLoading}
                                value={options.find((option) => option.value === state[id] || option.label === state[id])}
                                onChange={handleSelectChange(id)}
                            />
                        </div>
                    </div>
                ))}

                <div className="create__form-row">
                    <label className="create__form-label">Set Password</label>
                    <div className="create__form-input">
                        <input
                            type="text"
                            id="password"
                            value={state.password}
                            disabled={state.force_password_change}
                            onChange={handleInputChange}
                            placeholder="Enter password"
                        />
                    </div>
                </div>
                <div className="create__form-row">
                    <label className="create__form-label"/>
                    <div className="create__form__wrapper">
                        {[
                            { label: "Deactivate User", id: "deactivated" },
                            { label: "Force Password Change", id: "force_password_change" },
                        ].map(({ label, id }) => (

                            <div key={id} className='create__form_checkboxContainer'>
                                <div className="a-checkbox">
                                    <input
                                        id={id}
                                        type="checkbox"
                                        checked={state[id]}
                                        onChange={handleCheckboxChange(id)}
                                    />
                                    <label htmlFor={id} style={{ fontSize: 14, marginTop:0 }}>
                                        {label}
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
            <div className="create__form-btns">
                <button type="button" onClick={() => navigate("/secondary-pages/users")} className="create__form-back">
                   Cancel
                </button>
                <button onClick={navigateToNextStep}  className="create__form-next">
                    <span>Next</span>
                    <span>
                        <img src="/assets/icons/next-icon.svg" alt="icon" />
                    </span>
                </button>

            </div>
        </form>
    );
};

export default CreateUser1;
